export interface ILastVisitedRoute {
  routeName: string;
  expirationTime: number;
  userId: string;
  currentCompanyId: string;
}

export const ROUTE_STATE_KEY = "ROUTE_STATE";
export const CURRENT_THEME_KEY = "CURRENT_THEME";
